module.exports = __webpack_public_path__ + "static/img/category_10.c19ac1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/category_10.jpg
// module id = ozlx
// module chunks = 1